import {InternalLinkOption} from "../option"
import {LexicalEditor} from "lexical"

import {PopoverMenuItemType} from "../../../../popover-menu/popover-menu/const"
import {EntitySelectorEntityType} from "../../../../entity-selector/@const"
import {lexicalInsertMentionTrigger} from "../../../actions/insert-mention-trigger"
import {EntitySelectorSettings} from "../../../editor"
import slashMenu_iconComponent from "./slah-menu-icon-component"

export default function editor_linkOptions(editor: LexicalEditor, entitySelectorSettings: EntitySelectorSettings) {

    const userMention = new InternalLinkOption('User mention', {
        id              : 'userMention',
        // icon            : 'editor-i5-mention fs-16',
        iconComponent   : slashMenu_iconComponent('editor-i5-mention'),
        keywords        : ['user', 'mention'],
        action          : () => {
            entitySelectorSettings.entityType = EntitySelectorEntityType.USER
            lexicalInsertMentionTrigger(editor)
        }
    })

    const linkTask = new InternalLinkOption('Link a task', {
        id              : 'linkTask',
        // icon            : 'i5-task',
        iconComponent   : slashMenu_iconComponent('i5-task'),
        keywords        : ['link', 'task'],
        action          : () =>{
            entitySelectorSettings.entityType = EntitySelectorEntityType.TASK
            lexicalInsertMentionTrigger(editor)

            /*gd.modals.mentions.taskMention(gd.companyId, props.projectId, (result:any)=>{
                debug && console.log(debug, 'Task onSelect result', result)
                lexicalInsertMentionNode(editor, result)
            })*/
        }
    })

    const linkDocument = new InternalLinkOption('Link a document', {
        id              : 'linkDocument',
        // icon            : 'i5-file',
        iconComponent   : slashMenu_iconComponent('i5-file'),
        keywords        : ['link', 'note', 'document'],
        action          : () =>{
            entitySelectorSettings.entityType = EntitySelectorEntityType.DOCUMENT
            lexicalInsertMentionTrigger(editor)

            /*gd.modals.mentions.noteMention(gd.companyId, props.projectId, (result:any)=>{
                debug && console.log(debug, 'Document onSelect result', result)
                lexicalInsertMentionNode(editor, result)
            })*/
        }
    })

    const linkProject = new InternalLinkOption('Link a project', {
        id              : 'linkProject',
        // icon            : 'i5-project',
        iconComponent   : slashMenu_iconComponent('i5-project'),
        keywords        : ['link', 'project'],
        action          : () =>{
            entitySelectorSettings.entityType = EntitySelectorEntityType.PROJECT
            lexicalInsertMentionTrigger(editor)

            /*gd.modals.mentions.noteMention(gd.companyId, props.projectId, (result:any)=>{
                debug && console.log(debug, 'Document onSelect result', result)
                lexicalInsertMentionNode(editor, result)
            })*/
        }
    })

    const options = [
        userMention,
        linkDocument,
        linkTask,
        linkProject,
    ]

    let optionsBlockKeywords: string[] = []
    _.map(options, option=>optionsBlockKeywords = optionsBlockKeywords.concat(option.keywords))

    return [
        new InternalLinkOption('Mention/Link', {
            type        : PopoverMenuItemType.HEADER,
            keywords    : optionsBlockKeywords
        }),

        ...options,

        new InternalLinkOption('', {
            type        : PopoverMenuItemType.SEPARATOR,
            keywords    : optionsBlockKeywords
        }),
    ]
}